import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";
const initialState = {
  invoiceDetails: null,
  invoiceDetailsById: null,
  invoiceList: [],
  bills: [],
};
export const BillingSlice = createSlice({
  name: "billings",
  initialState,
  reducers: {
    setInvoiceDetails: (state, action) => {
      state.invoiceDetails = action.payload;
    },
    setInvoiceDetailsByInvoiceId: (state, action) => {
      state.invoiceDetailsById = action.payload;
    },
    setInvoiceList: (state, action) => {
      state.invoiceList = action.payload;
    },
    setBills: (state, action) => {
      state.bills = state.bills.filter(
        (bill) => bill.invoiceId !== action.payload.invoiceId
      );

      state.bills.push(action.payload);
    },
    resetBills: (state) => {
      state.bills = [];
    },
  },
});
export const {
  setInvoiceDetails,
  setInvoiceDetailsByInvoiceId,
  setInvoiceList,
  setBills,
  resetBills,
} = BillingSlice.actions;
export default BillingSlice.reducer;
